import React from "react";
import ResumeTitle from "./ResumeTitle";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <div className="w-full grid grid-cols-9 px-6">
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Experience" icon={<MdWork />} />
        <ResumeCard
          badge=""
          title="Web Developer"
          subTitle="Akualife Indonesia"
          des={
            <ul className="list-disc pl-6">
              <li>Developed a POS application.</li>
              <li>Managed and optimized MySQL database.</li>
              <li>Automated database backup and recovery processes.</li>
              <li>Monitored and resolved database performance issues.</li>
              <li>Maintained a WordPress-based website.</li>
              <li>Supported IT operations, and system troubleshooting to ensure smooth business processes.</li>
            </ul>
          }
        />
        {/* <ResumeCard
          badge=""
          title="Database Administrator"
          subTitle="Akualife Indonesia"
          des={
            <ul className="list-disc pl-6">
              <li>Managed and optimized MySQL database.</li>
              <li>Automated database backup and recovery processes.</li>
              <li>Monitored and resolved database performance issues.</li>
            </ul>
          }
        /> */}
        <ResumeCard
          badge=""
          title="School Secretary"
          subTitle="Sulaimaniyah"
          des={
          <ul className="list-disc pl-6">
            <li>Responsible for school administration, including document management, report preparation, and coordination of academic activities.</li>
          </ul>
          }
        />
      </div>
      <div className="w-full h-full hidden lgl:flex justify-center items-center">
        <span className="w-[1px] h-full bg-zinc-800 inline-flex"></span>
      </div>
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Education" icon={<GiGraduateCap />} />
        <ResumeCard
          badge=""
          title="Indraprasta University"
          subTitle="Jakarta"
          des={
            <ul className="list-disc pl-6">
              <li>Specialized in Software Development and Data Management.</li>
            </ul>
          }
        />
        <ResumeCard
          badge=""
          title="Programming Course"
          subTitle="Freecodecamp"
          des="Completed hands-on projects in HTML, CSS, JavaScript, Node.js, and React."
        />
        <ResumeCard
          badge=""
          title="Programming Course"
          subTitle="Dicoding"
          des="Mastered RESTful API development, authentication systems, and unit testing."
        />
      </div>
    </div>
  );
};

export default Education;
